module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-8.b8b3c805.jpg";